import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Alert } from '@mui/material';
import UsbIcon from '@mui/icons-material/Usb';
import SerialConnectButton from '../SerialConnectButton';

export default function ConnectPrompt({ onConnect, serialSupported }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 400,
        textAlign: 'center',
      }}
    >
      <UsbIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h5" gutterBottom>
        Connect your sensor
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 360 }}>
        Plug in your VPSI sensor via USB to get started.
      </Typography>
      <SerialConnectButton
        connected={false}
        onConnect={onConnect}
        onDisconnect={() => {}}
        disabled={!serialSupported}
      />
      {!serialSupported && (
        <Alert severity="warning" sx={{ mt: 3, maxWidth: 400 }}>
          Web Serial requires Chrome or Edge. Other browsers are not supported.
        </Alert>
      )}
    </Box>
  );
}

ConnectPrompt.propTypes = {
  onConnect: PropTypes.func.isRequired,
  serialSupported: PropTypes.bool.isRequired,
};
